export default {
    editsList(state) {
        return state.editsList;
    }
}
